export interface FactorySummary {
    factoryName: string;
    clusterName: string;
    factoryImage: string;
    totalWaste: number;
    arrow: boolean;
    totalWastePercentage: number;
    wasteContribution: number;
    uniqueLine: number;
    uniqueSKUs: number;
    carouselList: CarouselList[];
    zeroBasedTargetDeviationper: number;
}



interface CarouselList {
    content: string;
}

export class FactorySummaryDetails {
    clusterId?: string;
    clusterName?: string;
    factoryId?: string;
    factoryImage?: string;
    factoryName?: string;
    fromDate?: string;
    toDate?: string;
    sapPlantCode?: string;
    level?: string;
    lineId?: string;
}

export class TrendsResponse {
    actualConsumption?: ActualConsumption[];
    actualConsumptionWastePercentage?: ActualConsumptionWastePercentage[];
    wasteTargetPercentage?: number;
    wasteTargetCost?: number;
}

export class ActualConsumption {
    actualConsumptionCost?: number;
    dayOrMonth?: number;
    zeroBasedTarget?: number;
}

export class ActualConsumptionWastePercentage {
    dayOrMonth?: number;
    wastePercentage?: number;
}

export class BookMarkList {
    id?: number;
    screenName?: string;
    url?: string;
    notes?: string;
    createdBy?: string;
    createdOn?: Date;
}

export class OEEAndChangeOver {
    month?: number;
    costPercentage?: number;
    oee?: number;
    formatChangeOver?: number;
    productChangeOver?: number;
}

export class OEEGrapgData {
    xAxisLabels?: number[];
    oeeData?: number[];
    costPercentageData?: number[];
    monthName?: string;
    divisionNumber?: string;
    signType?: string;
}

export class RmPmCostContibutionResponse {
    materialGroupCostConsumption: MaterialGroupCostConsumption[];
    rmPmCostConsumption: RmPmCostConsumption[];
}

export class MaterialGroupCostConsumption {
    materialGroup?: string;
    materialType?: string;
    wasteCostEuro?: number;
}

export class RmPmCostConsumption {
    materialType?: string;
    wasteCostEuro?: number;
}
